import Model  from '@/util/models';

export default class Report extends Model { 
    backend = '/frc/report/'; 
    
    tps(params){
        return this.api.get(this.backend + 'tps', params);
    }
    
    kelurahans(params){
        return this.api.get(this.backend + 'kelurahans', params);
    }
    
    kecamatans(params){
        return this.api.get(this.backend + 'kecamatans', params);
    }
    
    kotas(params){
        return this.api.get(this.backend + 'kotas', params);
    }
    
    provinsis(params){
        return this.api.get(this.backend + 'provinsis', params);
    }
       
    kompetisisByArea(params){
        return this.api.get(this.backend + 'kompetisis-by-area', params);
    }   
       
    c1(params){
        return this.api.get(this.backend + 'c1', params);
    }   
     
    d1(params){
        return this.api.get(this.backend + 'd1', params);
    }
    
    da1(params){
        return this.api.get(this.backend + 'da1', params);
    }
    
    db1(params){
        return this.api.get(this.backend + 'db1', params);
    }
    
    dc1(params){
        return this.api.get(this.backend + 'dc1', params);
    }                             
}

